import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateOrderFulfillmentPictureMutationVariables = Types.Exact<{
  picture_id: Types.Scalars['ID'];
  update: Types.UpdateOrderFulfillmentPictureInput;
}>;


export type UpdateOrderFulfillmentPictureMutation = { __typename?: 'Mutation', updateOrderFulfillmentPicture: { __typename?: 'OrderFulfillmentPicture', id: string } };


export const UpdateOrderFulfillmentPictureDocument = gql`
    mutation UpdateOrderFulfillmentPicture($picture_id: ID!, $update: UpdateOrderFulfillmentPictureInput!) {
  updateOrderFulfillmentPicture(picture_id: $picture_id, update: $update) {
    id
  }
}
    `;
export type UpdateOrderFulfillmentPictureMutationFn = Apollo.MutationFunction<UpdateOrderFulfillmentPictureMutation, UpdateOrderFulfillmentPictureMutationVariables>;

/**
 * __useUpdateOrderFulfillmentPictureMutation__
 *
 * To run a mutation, you first call `useUpdateOrderFulfillmentPictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderFulfillmentPictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderFulfillmentPictureMutation, { data, loading, error }] = useUpdateOrderFulfillmentPictureMutation({
 *   variables: {
 *      picture_id: // value for 'picture_id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateOrderFulfillmentPictureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderFulfillmentPictureMutation, UpdateOrderFulfillmentPictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderFulfillmentPictureMutation, UpdateOrderFulfillmentPictureMutationVariables>(UpdateOrderFulfillmentPictureDocument, options);
      }
export type UpdateOrderFulfillmentPictureMutationHookResult = ReturnType<typeof useUpdateOrderFulfillmentPictureMutation>;
export type UpdateOrderFulfillmentPictureMutationResult = Apollo.MutationResult<UpdateOrderFulfillmentPictureMutation>;
export type UpdateOrderFulfillmentPictureMutationOptions = Apollo.BaseMutationOptions<UpdateOrderFulfillmentPictureMutation, UpdateOrderFulfillmentPictureMutationVariables>;